import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {MDIntent} from '@mintdata-wsp/common/components/MDIntent';

const styles = require('./Badge.less');
const cx = classnames.bind(styles);

export interface BadgeProps
{
    intent:MDIntent;
    label:string;
    style?:any;
}

@observer
export class Badge extends React.Component<BadgeProps, any>
{
    render()
    {
        const {intent, label, style} = this.props;

        return <div style={style} className={cx('badge',
                                    {'twoDigitsOrMore': label && label.length >= 2},
                                    {'defaultIntent': intent === MDIntent.Default},
                                    {'successIntent': intent === MDIntent.Success},
                                    {'warningIntent': intent === MDIntent.Warning},
                                    {'dangerIntent': intent === MDIntent.Danger}
                                    )}>
                    {label}
                </div>;
    }
}





